// Port de app/portal-web.tsx.
import { Carregando } from "@/app/Carregando";
import { Stack } from "@/navigation";
import { lazy } from "react";

const PRIMARY = "#294956";

const PortalWebScreen = lazy(() => import("@/screens/PortalWeb"));

export default function PortalWebRoute() {
  return (
    <>
      {/* Ver comentário em suporte-chat.tsx: das opções de barra do sistema, no web só a
          cor importa (<meta name="theme-color">). */}
      <Stack.Screen
        options={{
          statusBarBackgroundColor: PRIMARY,
          navigationBarColor: PRIMARY,
          statusBarTranslucent: false,
        }}
      />
      <Carregando cor={PRIMARY}>
        <PortalWebScreen />
      </Carregando>
    </>
  );
}
